// THEME OVERRIDE (INP): stock Horizon reads window.innerWidth inside this handler, which forces a
// synchronous style/layout recalc on mobile (~20ms+ per click). Uses a cached matchMedia instead and
// bails early when nothing is open. Keep this change when merging Horizon updates.
(function autoCloseDetails() {
  const desktopQuery = window.matchMedia('(min-width: 750px)');

  document.addEventListener('click', function (event) {
    const openDetails = document.querySelectorAll('details[data-auto-close-details][open]');
    if (!openDetails.length) return;

    const closingOn = desktopQuery.matches ? 'desktop' : 'mobile';

    for (const detailsElement of openDetails) {
      if (
        detailsElement.getAttribute('data-auto-close-details')?.includes(closingOn) &&
        !(event.target instanceof Node && detailsElement.contains(event.target))
      ) {
        detailsElement.removeAttribute('open');
      }
    }
  });
})();
